import { Component, OnDestroy } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { UserCloseAccountComponent } from './user-close-account/user-close-account.component'
import { Address, CustomerInformationState, selectProfileState } from './user-profile.state'
import { Observable, Subscription, tap } from 'rxjs'
import { Store } from '@ngrx/store'
import { KeycloakService } from 'keycloak-angular'
import { Router } from '@angular/router'
import { AddressActions } from '../user-addresses/user-addresses.actions'
import { environment } from '@environment/environment'

@Component({
  selector: 'cover-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnDestroy {
  customer: Observable<CustomerInformationState>
  address: Address | undefined
  addressSubscription: Subscription | undefined
  customerSubNr: string | undefined
  email: string | undefined

  readonly showPasswordReset: boolean = !!environment.features.complaintInUserAddress

  constructor(
    private readonly dialog: MatDialog,
    private readonly store: Store,
    private readonly keycloak: KeycloakService,
    private readonly router: Router,
  ) {
    this.customer = store.select(selectProfileState.customerInformationState)
    this.addressSubscription = this.customer
      .pipe(
        tap(state => {
          this.address = state.address
          this.customerSubNr = state.customerSubNumber
        }),
      )
      .subscribe()
    this.keycloak.loadUserProfile(false).then(profile => (this.email = profile.email))
  }

  ngOnDestroy(): void {
    this.addressSubscription?.unsubscribe()
  }

  onCloseAccount(): void {
    this.dialog.open(UserCloseAccountComponent)
  }

  edit(): void {
    if (this.address) {
      this.store.dispatch(AddressActions.setAddressToEdit({ payload: this.address }))
      this.router.navigateByUrl('/navigation/account/address/edit')
    }
  }

  changePassword(): void {
    this.keycloak.login({
      action: 'UPDATE_PASSWORD',
      redirectUri: window.location.href,
      // prompt: 'none' // @TODO: check if this helps in users not having to authenticate themselves again after a certain period
    })
  }

  isEmptyObject(obj: any): boolean {
    return Object.values(obj).every(x => x === null || x === '')
  }
}
